import { CallStatus } from '../../../teams-call';
import { CaMeetingRequestContext, CaResult } from '../core';

export interface CaAnalysisDialogState {
    minimized?: boolean;
    statuses: CallStatus[];
    transcriptStatus: 'grey' | 'green';
    meetingRequestContext?: CaMeetingRequestContext;
    result?: CaResult;
}

export const defaultState = (): CaAnalysisDialogState => ({
    statuses: [],
    transcriptStatus: 'grey',
});
